<template>
  <header class="page-head">
    <div class="rd-navbar-wrap">
      <nav
        class="rd-navbar rd-navbar-corporate-dark"
        :data-layout="layout"
        :data-sm-layout="layout"
        :data-md-device-layout="layout"
        :data-md-layout="layout"
        :data-lg-layout="lgLayout"
        :data-xl-layout="xlLayout"
        :data-xxl-layout="xxlLayout"
        :data-lg-device-layout="lgLayout"
        :data-xl-device-layout="xlLayout"
        :data-xxl-device-layout="xxlLayout"
        :data-stick-up-clone="stickUpClone"
        :data-md-stick-up-offset="stickUpOffset"
        :data-lg-stick-up-offset="stickUpOffset"
        :data-lg-stick-up="lgStickUp"
        :data-xl-stick-up="xlStickUp"
        :data-xxl-stick-up="xxlStickUp"
      >
        <div class="rd-navbar-inner">
          <!-- 主导航区域 -->
          <div class="rd-navbar-group">
            <div class="rd-navbar-nav-wrap">
              <ul class="rd-navbar-nav">
                <li :class="{ active: isActive('index') }">
                  <router-link to="/">首页</router-link>
                </li>
                <li :class="{ active: isActive('lr') }">
                  <router-link to="/lr">LR</router-link>
                </li>
                <li :class="{ active: isActive('motion') }">
                  <router-link to="/motion">Motion</router-link>
                </li>
                <li :class="{ active: isActive('kuaijian') }">
                  <router-link to="/kuaijian">快剪</router-link>
                </li>
                <li :class="{ active: isActive('yinghua') }">
                  <router-link to="/yinghua">樱花校园</router-link>
                </li>
                <li :class="{ active: isActive('yingtao') }">
                  <router-link to="/yingtao">樱桃视频</router-link>
                </li>
                <li :class="{ active: isActive('kuaiying') }">
                  <router-link to="/kuaiying">快赢</router-link>
                </li>
                <li :class="{ active: isActive('xiangjiao') }">
                  <router-link to="/xiangjiao">香蕉剪辑</router-link>
                </li>
                <li :class="{ active: isActive('hsjt') }">
                  <router-link to="/hsjt">微商截图王</router-link>
                </li>
                <li :class="{ active: isActive('faceapp') }">
                  <router-link to="/faceapp">FaceApp</router-link>
                </li>
                <li :class="{ active: isActive('facetune') }">
                  <router-link to="/facetune">Facetune</router-link>
                </li>
                <li :class="{ active: isActive('meiying') }">
                  <router-link to="/meiying">魅影</router-link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'Header',
  setup() {
    const route = useRoute()

    // 响应式导航配置
    const layout = ref('rd-navbar-fixed')
    const lgLayout = ref('rd-navbar-static')
    const xlLayout = ref('rd-navbar-static')
    const xxlLayout = ref('rd-navbar-static')
    const stickUpClone = ref(false)
    const stickUpOffset = ref('53px')
    const lgStickUp = ref(true)
    const xlStickUp = ref(true)
    const xxlStickUp = ref(true)

    // 检测当前路由
    const isActive = (routeName) => {
      return route.name === routeName
    }

    // 窗口大小变化处理
    const handleResize = () => {
      const width = window.innerWidth

      if (width >= 1400) {
        // XXL 屏幕
        layout.value = 'rd-navbar-static'
      } else if (width >= 1200) {
        // XL 屏幕
        layout.value = 'rd-navbar-static'
      } else if (width >= 992) {
        // LG 屏幕
        layout.value = 'rd-navbar-static'
      } else if (width >= 768) {
        // MD 屏幕
        layout.value = 'rd-navbar-fixed'
      } else {
        // SM 及以下
        layout.value = 'rd-navbar-fixed'
      }
    }

    // 初始化和清理
    onMounted(() => {
      handleResize()
      window.addEventListener('resize', handleResize)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })

    return {
      layout,
      lgLayout,
      xlLayout,
      xxlLayout,
      stickUpClone,
      stickUpOffset,
      lgStickUp,
      xlStickUp,
      xxlStickUp,
      isActive
    }
  }
}
</script>

<style>
/* 导航栏基础样式 */
.page-head {
  position: relative;
  z-index: 1000;
}

.rd-navbar-wrap {
  position: relative;
}

.rd-navbar {
  display: block;
  background: #212121;
}

.rd-navbar-corporate-dark {
  background: #212121;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.rd-navbar-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  width: 100%;
  margin: 0 auto;
}

.rd-navbar-group {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.rd-navbar-nav-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  overflow: visible;
}

.rd-navbar-nav {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  flex-wrap: nowrap;
  justify-content: center;
  white-space: nowrap;
  width: 100%;
}

.rd-navbar-nav li {
  position: relative;
  flex-shrink: 1;
  flex-grow: 1;
  text-align: center;
}

.rd-navbar-nav li a {
  display: block;
  padding: 18px 8px;
  color: #fff;
  text-decoration: none;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.2px;
  transition: all 0.3s ease;
  white-space: nowrap;
  text-align: center;
}

.rd-navbar-nav li a:hover,
.rd-navbar-nav li.active > a,
.rd-navbar-nav li a.router-link-active,
.rd-navbar-nav li a.router-link-exact-active {
  color: #e03c31;
}

.rd-navbar-nav li.active > a,
.rd-navbar-nav li a.router-link-active,
.rd-navbar-nav li a.router-link-exact-active {
  border-bottom: 2px solid #e03c31;
}

/* 大屏幕 - 1400px 以上 */
@media (min-width: 1400px) {
  .rd-navbar-nav li a {
    padding: 20px 16px;
    font-size: 14px;
    letter-spacing: 0.5px;
  }
}

/* 大屏幕 - 1200px 到 1399px */
@media (max-width: 1399px) and (min-width: 1200px) {
  .rd-navbar-nav li a {
    padding: 18px 12px;
    font-size: 13px;
  }
}

/* 中等屏幕 - 992px 到 1199px */
@media (max-width: 1199px) and (min-width: 992px) {
  .rd-navbar-nav li a {
    padding: 16px 10px;
    font-size: 12px;
  }
}

/* 小屏幕 - 768px 到 991px */
@media (max-width: 991px) and (min-width: 768px) {
  .rd-navbar-inner {
    padding: 0 3px;
  }

  .rd-navbar-nav li a {
    padding: 14px 6px;
    font-size: 11px;
    letter-spacing: 0;
  }
}

/* 超小屏幕 - 576px 到 767px */
@media (max-width: 767px) and (min-width: 576px) {
  .rd-navbar-inner {
    padding: 0 2px;
  }

  .rd-navbar-nav li a {
    padding: 12px 4px;
    font-size: 10px;
    letter-spacing: 0;
  }
}

/* 极小屏幕 - 575px 以下 */
@media (max-width: 575px) {
  .rd-navbar-inner {
    padding: 0;
  }

  .rd-navbar-nav-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
    justify-content: flex-start;
  }

  .rd-navbar-nav-wrap::-webkit-scrollbar {
    display: none;
  }

  .rd-navbar-nav {
    justify-content: flex-start;
    flex-wrap: nowrap;
  }

  .rd-navbar-nav li {
    flex-shrink: 0;
  }

  .rd-navbar-nav li a {
    padding: 10px 5px;
    font-size: 9px;
    letter-spacing: 0;
  }
}
</style>
